import templateUrl from "./news-category-list.html";
import "../news-category.scss";

export const newsCategoryListComponent = {
  bindings: {
    details: "<",
  },
  templateUrl,

  controller: class NewsCategoryListComponent {
    constructor($state, toastr, NewsCategoryService, ModalService) {
      "ngInject";
      this.$state = $state;
      this.toastr = toastr;
      this.modalService = ModalService;
      this.NewsCategoryService = NewsCategoryService;
    }

    onDelete(data) {
      const bodyMsg = "Are you sure to delete this category?";
      this.modalService.open({
        details: {
          bodyMessage: bodyMsg,
        },
        buttons: [
          {
            name: "No",
            action() {},
          },
          {
            name: "Yes",
            isPrimary: true,
            action: _onDelete.bind(this, data),
          },
        ],
      });
      function _onDelete(data) {
        this.NewsCategoryService.deleteNewsCategory(data.newsCategoryId)
          .then((_) => {
            this.toastr.success("Category deleted successfully!!");
            this.$state.reload();
          })
          .catch((err) => {
            this.toastr.error(err);
          });
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/news-category/news-category-list/news-category-list.component.js